export default __webpack_public_path__ + "static/media/q2_2_step2.95bef2e3.png";